import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { watermarkService, WatermarkPayload } from '@/services/watermarkService';

export const watermarkKeys = {
  all: ['watermarks'] as const,
};

export const useWatermarks = () =>
  useQuery({
    queryKey: watermarkKeys.all,
    queryFn: watermarkService.getWatermarks,
    select: (data) => data.watermarks,
  });

export const useCreateWatermark = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WatermarkPayload) => watermarkService.createWatermark(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watermarkKeys.all }),
  });
};
